import React, {useEffect, useState} from 'react';
import './MainPage.scss';
import SideBar from './SideBar';
import MainWindow from './MainWindow';
import {determineScreenSize} from "../../store/actions/toggleModalActions";
import {useDispatch, useSelector} from "react-redux";
import MobileTopNavigation from "./MobileTopNavigation";

const selector = state => {
    const { language,  modalState } = state;
    return {
        t: language.translator,
        modalState: modalState

    }
};

const MainPage = () => {
    const dispatch = useDispatch();
    const { t, modalState} = useSelector(selector)
    // const [isTabletOrLess, setIsTabletOrLess] = useState(checkScreenSize());

    function checkScreenSize() {
        const breakpoint = 932;
        return window.innerWidth <= breakpoint;
    }

    useEffect(() => {
        function handleResize() {
            dispatch(determineScreenSize(checkScreenSize()));
        }

        handleResize();

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div className='app'>
            {modalState.isTabletOrMobile && (
                <MobileTopNavigation />
            )}
            <div className='mainPage'>
                {!modalState.isTabletOrMobile && (
                    <SideBar />
                )}
                <MainWindow />
            </div>
        </div>
    );
}

export default MainPage;
